<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title='"周年庆生，蛋糕狂欢"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-td' v-show='preloadingShow'></div>
    </transition>

    <Header
      v-if='true'
      :config='headerConfig'
      :isShowInfo='false' />

    <div class="help-page">
      <div class="home-page">
        <div class="logo">
          <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
            <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/logo.png"/>
          </transition>
        </div>
        <div class="title">
          <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
            <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/title.png"/>
          </transition>
        </div>
        <div class="menu_btn" @click="openPopup('detailShow')"></div>
        <div class="group_btn" @click="goJoinGroup()"></div>
        <div class="reward_btn" @click="openPopup('rewardShow')"></div>
        <div class="help_btn" @click="onHelp()"></div>
      </div>
      <Footer :gameName="gameName" />
    </div>

    <!-- 弹窗类 -->
    <!-- 活动详情 -->
    <div class="detail_wrap popup_wrap" v-if="detailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="detail_box popup_wrap_box" v-show="detailShow" @click="closePopup('detailShow')"></div>
      </transition>
      <div class="close-bg" v-show="detailShow" @click="closePopup('detailShow')"></div>
    </div>
    <!-- 奖励列表 -->
    <div class="reward_wrap popup_wrap" v-if="rewardShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="reward_box popup_wrap_box" v-show="rewardShow">
          <div class="cake_total"><span>0</span></div>
        </div>
      </transition>
      <div class="close-bg" v-show="rewardShow" @click="closePopup('rewardShow')"></div>
    </div>
    <!-- 助力成功 -->
    <div class="help_wrap popup_wrap" v-if="helpSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help_success_box popup_wrap_box" v-show="helpSuccessShow">
          <div class="download_btn" @click="onDownload()"></div>
          <div class="active_btn" @click="onActive()"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="helpSuccessShow" @click="closePopup('helpSuccessShow')"></div>
    </div>
    <!-- 助力失败 已助力 -->
    <div class="help_wrap popup_wrap" v-if="helpedFailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="helped_box popup_wrap_box" v-show="helpedFailShow">
          <div class="download_btn" @click="onDownload()"></div>
          <div class="active_btn" @click="onActive()"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="helpedFailShow" @click="closePopup('helpedFailShow')"></div>
    </div>
    <!-- 助力失败 不能自己助力自己 -->
    <div class="help_wrap popup_wrap" v-if="helpSelfFailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help_self_box popup_wrap_box" v-show="helpSelfFailShow">
          <div class="download_btn" @click="onDownload()"></div>
          <div class="active_btn" @click="onActive()"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="helpSelfFailShow" @click="closePopup('helpSelfFailShow')"></div>
    </div>
    <!-- 助力失败 助力上限 -->
    <div class="help_wrap popup_wrap" v-if="helpMaxFailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help_max_box popup_wrap_box" v-show="helpMaxFailShow">
          <div class="download_btn" @click="onDownload()"></div>
          <div class="active_btn" @click="onActive()"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="helpMaxFailShow" @click="closePopup('helpMaxFailShow')"></div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, onHelpAPI } from '../api';
import { getRandomString, buriedLogger, analysisParams } from '@/utils/utils';
export default {
  name: 'anniversary_help',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      headerConfig,
      gameName: 'tideng',
      preloadingShow: true,
      titleShow: true,
      logger: null,

      // 业务弹窗
      detailShow: false,
      rewardShow: false,
      helpSuccessShow: false,
      helpedFailShow: false,
      helpSelfFailShow: false,
      helpMaxFailShow: false,

      activeUrl: null,
      friendId: null
    };
  },
  created () {
    onGetInitDataAPI().then(response => {
      this.onInitDataCallback(response, {needAccount: false, needUpdateInfo: false, name});
      this.preloadingShow = false;
    });

    const { protocol, host } = window.location;
    const params = analysisParams(window.location.href);
    this.friendId = params.id;
    this.activeUrl = `${protocol}//${host}/tideng/anniversary/enter${getRandomString()}`;

    // 埋点
    const bl = buriedLogger('tideng', '周年庆H5活动_助力页');
    this.logger = bl;

    this.setShare({
      title: '周年庆生，蛋糕狂欢',
      desc: '提灯二周年联动进行中！帮五郎切得更多蛋糕，即可获得丰厚游戏奖励哦~',
      imgUrl: 'https://download4.qcplay.com/tideng/active/anniversary_share_image_m.jpg'
    });
  },
  computed: {
    ...mapState([])
  },
  methods: {
    openPopup (name) {
      this[name] = true;
      const map = {
        detailShow: '活动详情',
        rewardShow: '奖励礼包'
      };
      if (map[name]) {
        this.logger.sum(`周年庆H5活动_${map[name]}`);
      }
    },
    closePopup (name) {
      this[name] = false;
    },
    goJoinGroup () {
      window.location.href = 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=33';
    },
    onDownload () {
      window.location.href = 'https://tideng.qingcigame.com/leading/';
    },
    onActive () {
      window.location.href = this.activeUrl;
    },
    onHelp () {
      if (!this.friendId) {
        this.onToast('无效助力链接！');
        return false;
      }
      onHelpAPI({ friend_id: this.friendId })
        .then(response => {
          const { code, message } = response;
          switch (code) {
            case 200:
              this.openPopup('helpSuccessShow');
              break;
            case 404: // 不能助力自己
              this.openPopup('helpSelfFailShow');
              break;
            case 406: // 助力上限
              this.openPopup('helpMaxFailShow');
              break;
            case 407: // 已助力
              this.openPopup('helpedFailShow');
              break;
            default:
              this.onToast(message);
          }
        });
      this.logger.sum('周年庆H5活动_好友助力');
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([]),
    ...mapActions(['onInitDataCallback', 'setShare'])
  }
};
</script>

<style lang='less'>
  @import url('../index/index.less');
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/tideng/anniversary/help/index.vue